<template>
    <div class="slider" ref="slider">
        <div :class="processClass" :style="{width}"></div>
        <!-- <div class="process" :style="{width}"></div> -->
        <div class="thunk" ref="trunk" :style="{left}">
            <div class="block" :style="borderStyle"></div>
            <div class="tips" :style="colorStyle">
                <span>{{Math.round(scale*100)}}%</span>
                <i class="fas fa-caret-down" ></i>
            </div>
        </div>
    </div>
</template>
<script>
  export default{
      data () {
          return {
              slider: null, // 滚动条DOM元素
              thunk: null, // 拖拽DOM元素
              per: 0, // 当前值
              colorStyle: 'background:#409eff',
              borderStyle: 'border:2px solid #409eff',
              processClass: 'process'
          };
      },
      created () {
          if (this.formData && this.formField && !isNaN(this.formData[this.formField])) {
              // this.per = Number(this.formData[this.formField].toString().match(/^\d+(?:\.\d{0,2})?/));
              this.per = Number(this.formData[this.formField]);
          } else if (this.value) {
              this.per = this.value;
          } else {
              this.per = 0;
          }
      },
      props: {
          min: {
              type: Number,
              default: 0
          },
          max: {
              type: Number,
              default: 100
          },
          value: {
              type: Number,
              default: 0
          },
          formData: {
              type: Object
          },
          formField: {
              type: String
          },
          field: {
              type: Object
          },
          fieldsList: {
              type: Array,
              default: () => { return []; }
          }
      },
      // 渲染到页面的时候
      mounted () {
          this.slider = this.$refs.slider;
          this.thunk = this.$refs.trunk;
          var _this = this;
          this.thunk.onmousedown = function (e) {
              var width = parseInt(_this.width);
              var disX = e.clientX;
              document.onmousemove = function (e) {
                  // value, left, width
                  // 当value变化的时候，会通过计算属性修改left，width

                  // 拖拽的时候获取的新width
                  var newWidth = e.clientX - disX + width;
                  // 拖拽的时候得到新的百分比
                  var scale = newWidth / _this.slider.offsetWidth;
                  scale = scale.toFixed(2);
                  _this.per = Math.ceil((_this.max - _this.min) * scale + _this.min);
                  _this.per = Math.max(_this.per, _this.min);
                  _this.per = Math.min(_this.per, _this.max);
              };
              document.onmouseup = function () {
                  document.onmousemove = document.onmouseup = null;
              };
              return false;
          };
      },
      computed: {
          // 设置一个百分比，提供计算slider进度宽度和trunk的left值
          // 对应公式为  当前值-最小值/最大值-最小值 = slider进度width / slider总width
          // trunk left =  slider进度width + trunk宽度/2
          // scale () {
          //     let number = (this.per - this.min) / (this.max - this.min);
          //     this.formData[this.formField] = number * 100;
          //     return number;
          //     // if (number < 1) {
          //     //     console.log(number.toFixed(2));
          //     //     return number.toFixed(2);
          //     // } else {
          //     //     console.log(Math.round(number));
          //     //     return Math.round(number);
          //     // }
          // },
          scale: {
              get () {
                  let number = (this.per - this.min) / (this.max - this.min);
                  if (this.formData && this.formField) {
                      this.formData[this.formField] = Math.round(number * 100);
                      this.setProgressStatus();
                  }
                  return number;
              },
              set (v) {
                  this.scale = v;
              }
          },

          width () {
              if (this.slider) {
                  return this.slider.offsetWidth * this.scale + 'px';
              } else {
                  return 0 + 'px';
              }
          },
          left () {
              if (this.slider) {
                  return this.slider.offsetWidth * this.scale - this.thunk.offsetWidth / 2 + 'px';
              } else {
                  return 0 + 'px';
              }
          }
      },
      methods: {
          getCurrentProcessVal () {
              return Math.round(this.scale * 100);
          },
          setProgressStatus () {
              if (this.field && this.field.type === 'number' && this.field.options.isProgress) {
                  if (this.formData[this.field.options.progressDateField]) {
                      let targetTime = this.formData[this.field.options.progressDateField];
                      // let targetTimeObj = this.fieldsList.find(item => item.id === this.field.options.progressDateField);
                      if (Array.isArray(targetTime)) {
                          targetTime = targetTime[1];// 取截止时间
                      }
                      let progressData = this.formData[this.field.formField];// 当前进度值
                      progressData = progressData ? parseInt(progressData) : 0;
                      let progressTime = new Date(targetTime).getTime();
                      let currentTime = new Date().getTime();
                      // this.progressContent = '输入进度值，不能超过100。进度比较规则：系统当前时间与日期字段【' + targetTimeObj.name + '】相比';
                      if (progressData === 100) { // 当前时间等于目标时间，且进度等于100
                          this.colorStyle = 'background:#67C23A';
                          this.borderStyle = 'border:2px solid #67C23A';
                          this.processClass = 'processSuccess';
                      } else if (progressTime < currentTime && progressData < 100) { // 当前时间 大于 截止目标时间，且进度小于100
                          this.colorStyle = 'background:#F56C6C';
                          this.borderStyle = 'border:2px solid #F56C6C';
                          this.processClass = 'processWarning';
                      }
                  }
              }
          }
      }
  };
</script>
<style>
  .slider .box{margin:100px auto 0;width:80%}
  .slider .clear:after{content:'';display:block;clear:both} 
  .slider{position:relative;margin:10px 32px;width:400px;height:10px;background:#e4e7ed;border-radius:5px;cursor:pointer}
  .slider .process{position:absolute;left:0;top:0;width:112px;height:10px;border-radius:5px;background:#409eff}
  .slider .processSuccess{position:absolute;left:0;top:0;width:112px;height:10px;border-radius:5px;background:#67C23A}
  .slider .processWarning{position:absolute;left:0;top:0;width:112px;height:10px;border-radius:5px;background:#F56C6C}
  .slider .thunk{position:absolute;left:100px;top:-7px;width:50px;height:20px}
  .slider .block{width:20px;height:20px;border-radius:50%;border:2px solid #409eff;background:rgba(255,255,255,1);transition:.2s all}
  /* .slider .tips{position:absolute;left:-7px;bottom:30px;min-width:15px;text-align:center;padding:4px 8px;background:#409eff;border-radius:5px;height:24px;color:#fff} */
  .slider .tips{position:absolute;left:30px;bottom:-10px;min-width:39px;text-align:center;padding:1px 1px;background:#409eff;border-radius:5px;color:#fff}
  .slider .tips i{position:absolute;margin-left:-5px;left:50%;bottom:-9px;font-size:16px;color:#000}
  .slider .block:hover{transform:scale(1.1);opacity:.6}
</style>


// WEBPACK FOOTER //
// src/components/ProcessSlider/ProcessSlider.vue